import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator} from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getDatabase } from 'firebase/database';
import { GoogleAuthProvider, signInWithPopup, getAdditionalUserInfo, getAuth, connectAuthEmulator } from "firebase/auth";
import { httpsCallable } from "firebase/functions";

import { addUserToFirestore } from "database/Firestore";

const config = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PID,
  storageBucket: process.env.REACT_APP_SB,
  messagingSenderId: process.env.REACT_APP_SID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MID,
};

const app = initializeApp(config);

const firestore = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

// if (
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1"
// ) {
//   console.log("🔥 USING FIREBASE EMULATORS");

//   connectFunctionsEmulator(functions, "127.0.0.1", 5001);
//   connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
//   connectAuthEmulator(auth, "http://localhost:9099");
// }





/** To sign up using google
 * Link for developer documentation (https://firebase.google.com/docs/auth/web/google-signin)
*/
const provider = new GoogleAuthProvider();


provider.setCustomParameters({
  prompt: "select_account",
});

const signInWithGoogle = async () => {
  try {
    let response = await signInWithPopup(auth, provider);
    if (response) {
      let additionalUserInfo = getAdditionalUserInfo(response);
      console.log(additionalUserInfo?.isNewUser);
      await addUserToFirestore({ user: response.user });
    }
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const signOut = () => auth.signOut();

const isUserPremium = async () => {
const user = auth.currentUser;

  if (!user) return false;

  return user.providerData.some(
    (provider) => provider.providerId === "google.com"
  );
};


export const db = getDatabase(app);
export { signInWithGoogle, firestore, auth, signOut, isUserPremium, app, functions };